import React from "react"

import Image from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Image"
import Link from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Link"
import Headline from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Headline"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowRight } from "@fortawesome/pro-solid-svg-icons"

const NewsCard = ({ item }) => {
  return (
    <article className="block h-full shadow-lg border border-gray-100">
      <Link className="group" link={item.link}>
        <Image image={item.image} className="w-full" aspectRatio="3by2" />
        <div className="p-4">
          <Headline
            headline={item.headline}
            tagName="span"
            headlineLevel="h4"
          />
          <span className="block mt-2 group-hover:text-primary">
            Weiter
            <FontAwesomeIcon icon={faArrowRight} size="1x" className="ml-2" />
          </span>
        </div>
      </Link>
    </article>
  )
}

export default NewsCard
